module.exports = __webpack_public_path__ + "img/5.18dd6945.png";